<template>
  <div>
    <div class="m-background m-background--media-4"></div>
    <div class="m-background__overlay m-background__overlay--black"></div>
    <Header></Header>
    <div class="l-container l-container--with-header">
      <div class="m-game-over">
        <img class="m-game-over__icon" src="~@/assets/images/game-over.png" alt="!"/>
        <h3 class="m-game-over__title">Game Over</h3>
        <div class="m-game-over__body">
          <p class="">You have spent all your budget. Mega City is highly advanced
          but you don’t have any money left to sort out the remaining issues.</p>
          <p class="u-text--white">Play again to see if you can spend more carefully next time.</p>
        </div>
      </div>
      <div class="m-game-over__actions">
          <router-link class="m-btn m-btn--left m-btn__primary"
          :to="{ name: 'explore-careers' }">Explore Careers</router-link>
        <router-link class="m-btn m-btn--left m-btn__primary"
          :to="{ name: 'home' }">Play Again</router-link>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Header from '../components/header/Header';

export default {
  created() {
    this.storeResponsesInFirebase();
  },
  components: {
    Header,
  },
  computed: {
    ...mapGetters(['getBudget']),
  },
  methods: {
    ...mapActions(['setShowPromotionStatus', 'setGameOverStatus', 'storeResponsesInFirebase']),
    togglePromotion() {
      this.setShowPromotionStatus(false);
    },
    toggleGameOver() {
      this.setGameOverStatus(false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/GameOverLose.vue